/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable prefer-regex-literals */
/* eslint-disable regexp/no-unused-capturing-group */
/* cspell:disable */

import parse from 'html-react-parser';

import { removeScriptHTML } from './removeScriptHTML';

export const stringKey = '<param id="emblueHtmlUploader">';

export const prepareHtml = (html: string) => {
  const BODY_REGEX = /(<body)(>)|(<body)(.+)(>)/gi;
  const HEAD_BODY_REGEX = /<\/head\b[^<]*<body/gi;
  let originalBodyTag: RegExpMatchArray | null = null;
  let htmlModify = html;

  if (html && html.includes('##')) {
    htmlModify = cleanLinks(html);
  }

  if (HEAD_BODY_REGEX.test(htmlModify)) {
    originalBodyTag = htmlModify.match(BODY_REGEX);
    htmlModify = htmlModify.replace(HEAD_BODY_REGEX, `</head> ${stringKey} <body`);
  }

  return { preparedHtml: htmlModify, originalBodyTag: originalBodyTag ? originalBodyTag[0] : null };
};

export const assembleHtml = (html: string, originalBodyTag: string | null, emptyEditor: string) => {
  const MIDLE_LABEL = /\w(<param id="emblueHtmlUploader">)/gi;
  const isEmptyEditor = emptyEditor === 'true';

  if ((isEmptyEditor && MIDLE_LABEL.test(html)) || !html.includes(stringKey)) {
    html = html.replace(stringKey, '');
    html = stringKey + html;
  }
  // add border-color to tables display html
  if (html.includes('<table ')) {
    html = addBorderToTable(html);
  }

  if (html.includes(stringKey)) {
    html = removeScriptHTML(html);
    // Replace tag <param id="emblueHtmlUploader"> with </head> and originalBodyTag
    if (originalBodyTag) {
      html = html.replace(stringKey, `</head>${originalBodyTag}`);
    } else {
      html = html.replace(stringKey, '</head><body>');
    }
    // Complete html structure
    html = `<head>${html}</body>`;
  } else {
    html = `<head></head><body>${html}</body>`;
  }
  return html;
};

export const stringToReactDOM = (string: string) => parse(string);

export const replaceHexCharacters = (html: string) => {
  return html.replaceAll(/&amp;/g, '&').replace(/&#x9;|&#x3;|&#x9D;|&#xAD;|&#x9F;/g, '');
};

export const verifyHttpInLinks = (html: string) => {
  const htmlVerified = replaceHexCharacters(html);
  return htmlVerified.replace(
    /href="(?!mailto:)(?!http:)(?!https:)(?!tel:)(?!\$)([^"]+)"/g,
    (match, url) => {
      const verify = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/.test(url);
      if (verify) {
        return `href="mailto:${url}"`;
      } else if (!url.startsWith('$') && !url.startsWith('tel:')) {
        return `href="http://${url}"`;
      }
      return match;
    }
  );
};

export const cleanLinks = (html: string) => {
  html = html.replace(/##/g, '');

  const linkTags = [...html.matchAll(new RegExp('<a |<area ', 'gi'))].map((tag) => tag.index);

  let htmlModify = html;

  linkTags.forEach((element) => {
    const endTag = html.indexOf('</a>', element) + 4;
    const link =
      endTag > 3
        ? html.substring(element!, endTag)
        : html.substring(element!, html.indexOf('>', element) + 1);

    const id = link.match(/(?:\s|^)id="(\d+)"/);
    if (id) {
      const idTransform = id[1];
      const regex = new RegExp(`,${idTransform}`, 'g');
      const finalLink = link.replace(regex, '');
      htmlModify = htmlModify.replace(link, finalLink);
    }
  });
  return htmlModify;
};

export const addBorderToTable = (html: string) => {
  return html.replace(
    /<td[^>]+style="[^"]*border-color:([^;]+);[^"]*"[^>]*>/g,
    (match, borderColor) =>
      match.replace(/border-color:[^;]+;/, `border: 1px solid ${borderColor};`)
  );
};

export const cleanerHTML = (html: string) => {
  const el = document.createElement('div');
  el.innerHTML = html;

  const texto = el.textContent || '';
  el.remove();
  return texto;
};

export const secureLinks = (html: string) => {
  const htmlWithProtocols = verifyHttpInLinks(html);

  return htmlWithProtocols.replace(
    /<(a|area)\b([^>]*)href=["']([^"']*)["']/gi,
    (match, tag, attrs, url) => {
      if (attrs.includes('target=') || attrs.includes('rel=')) {
        return match;
      }
      return `<${tag}${attrs}href="${url}" target="_blank" rel="noopener noreferrer"`;
    }
  );
};
